module.exports = __webpack_public_path__ + "static/media/navigate-using-hex-viewer.bed24fe7.png";